class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.navStack = [];
    this.#relocatePanels();
  }

  connectedCallback() {
    this.mobileMenuElement = this.closest('.header__mobile-menu');
    this.mobileMenuHeaderElement = this.mobileMenuElement.querySelector('.header__mobile-menu-header');
    
    this.#setMobileMenuHeaderHeight();
    this.#relocatePanels();

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-trigger]');
      const back = event.target.closest('[data-action="back"]');

      if (trigger) {
        const submenuId = trigger.getAttribute('data-trigger');
        const submenu = this.querySelector(`#${CSS.escape(submenuId)}`);
        if (submenu) this.openSubmenu(submenu);
        return;
      }

      if (back) {
        this.closeSubmenu();
      }
    });
  }

  #setMobileMenuHeaderHeight() {
    if (this.mobileMenuHeaderElement) {
      this.mobileMenuElement.style.setProperty('--mobile-menu-header-height', `${this.mobileMenuHeaderElement.offsetHeight}px`);
    }
  }

  #relocatePanels() {
    const panels = this.querySelectorAll('.header__mobile-menu-submenu-panel');
    for (const panel of panels) {
      if (panel.parentElement !== this) {
        panel.classList.remove('is-active', 'is-parent');
        this.append(panel);
      }
    }
  }

  openSubmenu(submenu) {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');
    if (currentNav) {
      currentNav.classList.remove('is-active');
      currentNav.classList.add('is-parent');
      this.navStack.push(currentNav);
    }

    submenu.classList.add('is-active');
    this.scrollTo(0, 0);
  }

  closeSubmenu() {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');
    const prevNav = this.navStack.pop();

    if (currentNav) {
      currentNav.classList.remove('is-active');
    }
    if (prevNav) {
      prevNav.classList.remove('is-parent');
      prevNav.classList.add('is-active');
    }
  }

  reset() {
    const panels = this.querySelectorAll('.header__mobile-menu-submenu-panel');
    for (const panel of panels) {
      panel.classList.remove('is-active', 'is-parent');
    }

    const mainNav = this.querySelector('.header__mobile-menu-nav[data-level="1"]');
    if (mainNav) {
      mainNav.classList.add('is-active');
      mainNav.classList.remove('is-parent');
    }

    this.navStack = [];
    this.scrollTo(0, 0);
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}

